module.exports = __webpack_public_path__ + "img/icon-base.8750e2f1.png";